import { ConversationParticipation } from '@provision/entity-types';
import { gql, useQuery } from '@provision/graphql-client';
import { useMemo } from 'react';
import { CONVERSATION_CHANNEL_FIELDS } from 'src/graphql/entities/conversation-channel';
import { CONVERSATION_PARTICIPATION_FIELDS } from 'src/graphql/entities/conversation-participation/conversation-participation';
import { QueryVariables, Records } from 'src/graphql/types';

export interface GetConversationParticipation {
  getConversationParticipation: Records<ConversationParticipation>;
}

export const GET_CONVERSATION_PARTICIPATION_QUERY = gql`
  query GetConversationParticipation($params: QueryParams)
  @entity(name: "ConversationParticipation") {
    getConversationParticipation(queryParams: $params) {
      records {
        ...ConversationParticipationFields
        channel {
          ...ConversationChannelFields
        }
      }
    }
  }
  ${CONVERSATION_PARTICIPATION_FIELDS}
  ${CONVERSATION_CHANNEL_FIELDS}
`;

export const useConversationParticipationRecords = ({
  conversationId,
  skip,
  includeDeleted = false,
}: {
  conversationId: string;
  skip?: boolean;
  includeDeleted?: boolean;
}) => {
  const { data, loading } = useQuery<GetConversationParticipation, QueryVariables>(
    GET_CONVERSATION_PARTICIPATION_QUERY,
    {
      variables: {
        params: {
          filters: [{ attribute: 'conversationId', operator: '=', value: conversationId }],
          includeDeleted,
        },
      },
      skip: skip || !conversationId,
      context: {
        includePlatformLevelData: true,
      },
    },
  );

  const conversationParticipations = useMemo<ConversationParticipation[]>(() => {
    return data?.getConversationParticipation?.records ?? [];
  }, [data?.getConversationParticipation?.records]);

  return {
    conversationParticipations,
    isEnabled: true,
    isLoading: loading,
  };
};
